import {setupListeners} from '@reduxjs/toolkit/query/react';
import {configureStore} from '@reduxjs/toolkit/react';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';

import apis from './api/Apis';

export const store = configureStore({
  reducer: {
    [apis.reducerPath]: apis.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([apis.middleware]),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
